import { toast } from "react-toastify";

export * from "./routes";
export * from "./image";
export * from "./landing";
export * from "./menu";
export * from "./themes";
export * from "./messages";

// eslint-disable-next-line
export default {
  TOAST_POSITION: toast.POSITION.BOTTOM_RIGHT,
  DOCUMENT_SUPPORTED_TYPES: ["pdf", "png", "jpg", "jpeg"],
  DOCUMENT_IMAGE_SUPPORTED_TYPES: ["png", "jpg", "jpeg", "jfif"],
  SHOW_SIDE_CONTENTS: [
    "",
    "signin",
    "signup",
    "verify-email",
    "forgot-password",
    "reset-password",
  ],
  WEEK_DAYS: [
    {
      label: "S",
      value: 1,
      name: "Sunday",
    },
    {
      label: "M",
      value: 2,
      name: "Monday",
    },
    {
      label: "T",
      value: 3,
      name: "Tuesday",
    },
    {
      label: "W",
      value: 4,
      name: "Wednesday",
    },
    {
      label: "T",
      value: 5,
      name: "Thursday",
    },
    {
      label: "F",
      value: 6,
      name: "Friday",
    },
    {
      label: "S",
      value: 7,
      name: "Saturday",
    },
  ],
  MONTHS: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  APPOINTMENT_STATUS: {
    requested: "REQUESTED",
    accepted: "ACCEPTED",
    denied: "DENIED",
    cancelled: "CANCELLED",
    rescheduleRequest: "RESCHEDULE_REQUEST",
    autoDenied: "AUTO_DENIED",
    completed: "COMPLETED",
    noshow:"NO_SHOW",
  },
  NOTIFICATION_TYPES: {
    pcpRequest: "PCP_REQUEST",
    bookAppointment: "BOOK_APPOINTMENT",
    cancelledAppointment: "CANCELED_APPOINTMENT",
    acceptAppointment: "ACCEPTED_APPOINTMENT",
    deniedAppointment: "DENIED_APPOINTMENT",
    visitNow: "VISIT_NOW",
    nudgePermission: "NUDGE_PERMISSION",
    subscriptionPaymentAuth: "SUBSCRIPTION_PAYMENT_AUTH",
    trailEnd: "TRIAL_END",
    subscriptionExpiring: "SUBSCRIPTION_EXPIRING",
    chatNotification: "CHAT_NOTIFICATION",
    callStarted: "CALL_STARTED",
    appointmentCharges: "APPOINTMENT_CHARGE",
    noShowFees: "NO_SHOW_FEES",
    autoCancelled:"AUTO_CANCELLED"
  },
  TIMINGS: [
    {
      label: "Morning",
      value: "MORNING",
      name: "Morning",
    },
    {
      label: "Afternoon",
      value: "AFTERNOON",
      name: "Afternoon",
    },
    {
      label: "Evening",
      value: "EVENING",
      name: "Evening",
    },
    {
      label: "Bed Time",
      value: "NIGHT",
      name: "Bed Time",
    },
  ],

  FEETS: [
    { label: "1' ", value: 1 },
    { label: "2' ", value: 2 },
    { label: "3' ", value: 3 },
    { label: "4' ", value: 4 },
    { label: "5' ", value: 5 },
    { label: "6' ", value: 6 },
    { label: "7' ", value: 7 },
    { label: "8' ", value: 8 },
  ],

  INCHES: [
    { label: '0"', value: 0 },
    { label: '1"', value: 1 },
    { label: '2"', value: 2 },
    { label: '3"', value: 3 },
    { label: '4"', value: 4 },
    { label: '5"', value: 5 },
    { label: '6"', value: 6 },
    { label: '7"', value: 7 },
    { label: '8"', value: 8 },
    { label: '9"', value: 9 },
    { label: '10"', value: 10 },
    { label: '11"', value: 11 },
    { label: '12"', value: 12 },
  ],

  RECORD_TYPE: [
    { label: "Labs", value: "LABS" },
    { label: "Imaging", value: "IMAGING" },
    { label: "Consults", value: "CONSULTS" },
    { label: "Others", value: "OTHERS" },
  ],
  SPECIALITIES: [
    "Internal Medicine",
    "Family Medicine",
    "Pediatrics",
    "Urgent care",
    "Pediatrics",
    "Psychiatrist",
    "Cardiologist",
    "Pulmonologist",
    "Neurologist",
    "Dermatologist",
    "Nephrologist",
    "Hematologist Oncologist",
  ],

  PRIMARY_PHONE_TYPES: [
    { label: "Beeper", value: 1 },
    { label: "Cell", value: 2 },
    { label: "Fax", value: 3 },
    { label: "Home", value: 4 },
    { label: "Work", value: 5 },
    { label: "Night", value: 6 },
    { label: "Primary", value: 7 },
  ],
};
